import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';
import studioModalTemplate from '../../../../views/modals/studio-modal.tpl.html';
import StudioModalController from '../../../../controllers/modals/studio-modal-controller';

export default class AlGuestlistEditorStudioComponentController extends AbstractAlGuestlistEditorPagesController {

    constructor($injector, $scope) {
        super($injector, $scope);
        this.sweetAlert = $injector.get('SweetAlert');
        this.api = this.injector.get('$http');
        this.auth = this.injector.get('$auth');
        this.userStore = this.injector.get('Users');
        this.angularState = this.injector.get('$state');
        this.modal = this.injector.get('$uibModal');
        this.currentSite = null;
        this.availableTemplates = [];

        this._resetError();

        this.availableStudios = this.userStore.state.company.settings.guestlists.studio_urls;
    }

    createNewSiteForTemplate(template) {
        const apiData = {
            name: this.guestlist.name,
            slug: this.guestlist.uid.toLowerCase(),
            guestlistId: this.guestlist.id,
            guestlistUid: this.guestlist.uid,
            templateId: template.id,
            companyUid: _.get(this.userStore, 'state.company.uid', '')
        };
        this.api.post(template.backendUrl.concat(`/sites`), apiData).then((response) => {
            this.availableTemplates = [];
            this.currentSite = response.data.data;
        }).catch(exception => {
            this._setError('Error while creating site');
        });
    }

    canProceedToStudio() {
        return !!(this.guestlist.settings.enable_open_registration || this.guestlist.settings.enable_code_registration || this.guestlist.settings.enable_logged_in_registration);
    }

    openRegistrationTypeSettings() {
        this.angularState.go('app.guestlists.rsvps.edit-landingpage-settings', {gid: this.guestlistId});
    }

    openTemplatePreview(template) {
        window.open(template.preview, '_blank');
    }

    openStudioForPage(page) {
        this.modal.open({
            controller: StudioModalController,
            controllerAs: 'vm',
            templateUrl: studioModalTemplate,
            size: 'studio',
            resolve: {
                studioInformation: () => {
                    return this.currentSite;
                },
                user: () => {
                    return this.auth.getUser();
                }
            }
        });
    }

    openLoaderForPage(page) {
        window.open(page._links.loader, '_blank');
    }

    removeSite(site) {
        this.sweetAlert.swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this site.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                closeOnConfirm: false
            },
            (confirmed) => {
                if (confirmed) {
                    this.api.delete(`${site.backendUrl}/sites/${site.slug}`).then((response) => {
                        this.sweetAlert.close();
                        this.currentSite = null;
                        this._loadAvailableTemplates();
                    }).catch(exception => {
                        this._setError('Error while removing site');
                    });
                }

            });

    }

    _initFormConfig() {

    }

    /**
     * @private
     */
    _fillModelFromGuestlist() {
        this.model = {};

        this._updateStudioInformationForGuestlist()
            .then(() => {
                if (!this.currentSite) {
                    this._loadAvailableTemplates();
                }
            });
    }

    _updateStudioInformationForGuestlist() {
        const promises = [];
        _.each(this.availableStudios, (studio) => {
            promises.push(new Promise((resolve) => {
                this.api
                    .get(studio.url.concat(`/sites/by-guestlist/${this.guestlist.id}`))
                    .then((response) => {
                        this.currentSite = {
                            ...response.data.data,
                            backendUrl: studio.url
                        };
                        resolve();
                    })
                    .catch(() => {
                        resolve();
                    })
            }));
        });

        return Promise.all(promises);
    }

    _loadAvailableTemplates() {
        const company = _.get(this.userStore, 'state.company', '')
        const {uid, name} = company;
        this.availableTemplates = [];

        const promisesToWaitFor = [];

        _.each(this.availableStudios, (studio) => {
            if (!studio.active) {
                return;
            }
            promisesToWaitFor.push(this.api.post(`${studio.url}/templates/${uid}`, {
                name
            }).then((response) => {
                this.availableTemplates = _.concat(this.availableTemplates, _.map(response.data, (template) => {
                    return {
                        ...template,
                        backendUrl: studio.url
                    }
                }));
            })
                .catch(() => {
                }));
        });

        console.log(this.availableTemplates);

        Promise.all(promisesToWaitFor).then(() => {
            if (this.availableTemplates.length == 0) {
                this._setError('No templates are activated on your account, yet.');
            }
        })
    }

    _setError(message) {
        this.error = {
            active: true,
            message: message
        };
    }

    _resetError() {
        this.error = {
            active: false,
            message: ''
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/pages/studio/controller.js